import { Media, Texts, Title } from "../components/Object";
import { Scroll } from "../components/Animation";
import { Space, Table, QA } from "../components/Layout";
import { Head, News } from "../components/Project";

const Flow = () => {
  return (
    <>
      <Head slug="page-flow"></Head>
      <Space size={["80px", "64px"]} />

      <Space size={['0 0 120px', '0 0 80px']}>
        <FlowImgElm />
      </Space>

      <Information />

      <Space size={["120px 0", "80px 0"]}>
        <div className="l-row l-row--normal">
          <Follow />
        </div>
      </Space>
    
      <div id="qa">
        <Faq/>
      </div>
    

      <Space size={["120px 0 15px", "80px 0 12px"]}>
        <News />
      </Space>
    </>
  );
};

const FlowImgElm = () => {
  return(
    <>
      <div className="l-row" data-state="right">
        <div className="p-box__wrap--gray">
          <Space size={['100px', '72px']} />
          <div className="l-row l-row--normal">
            <div className="p-title__wrap--en">
              <Texts slug="flow/title" class="c-text--bold" />
            </div>
            <Scroll>
              <Space size={['64px 0 0', '48px 0 0']}>
                <Media src="flow/main" class="p-img__flow" alt="media" />
              </Space>
            </Scroll>

            <Space size={['120px 0', '80px 0']}>
              <div className="p-title__wrap--en">
                <Texts slug="flow/sec" class="c-text--bold"></Texts>
              </div>
              <Scroll>
                <Space size={['64px 0 0', '48px 0 0']}>
                  <Media src="flow/sec" sp="sp" class="p-img__flow--sec" alt="media" />
                </Space>
              </Scroll>
            </Space>

            <Space size={['0 0 120px', '0 0 80px']}>
              <div className="p-title__wrap--en">
                <Texts slug="flow/human" class="c-text--bold"></Texts>
              </div>
              <Space size={['64px 0 0', '48px 0 0']}>
                <HumanList />
              </Space>
              
            </Space>

            <div className="p-title__wrap--en">
              <Texts slug="flow/num" class="c-text--bold"></Texts>
            </div>
            <Scroll>
              <Space size={['64px 0 0', '48px 0 0']}>
                <Media src="flow/num" class="p-img__flow--num" alt="media" />
              </Space>
            </Scroll>
          </div>
          <Space size={['100px', '72px']} />
        </div>
      </div>
    </>
  )
}

const HumanList = () => {
  const addText = [
    '技能実習は、労働力不足を補うための手段として行うことはできません。',
    '18歳以上。',
    '技能実習制度の趣旨を理解して技能実習を行う外国人。',
    '本国に帰国後、修得した技能等を要する業務に従事する予定の方。',
    '同じ技能実習の段階（第一号技能実習、第二号又は第三号をいう。）を過去に行ったことがない方。',
  ]
  const Item = (props) => {
    return(
      <>
        <li className="c-grid__items--flow">
          <Media src="common/icon-check" alt="check"></Media>
          <Texts slug={`flow/list${props.index}`} addText={addText[props.index]}></Texts>
        </li>
      </>
    )
  }
  let items = [];
  for (let i = 0; i < 5; i++) {
    items.push(<Item key={i} index={i} />)
  }
  return(
    <>
      <ul className="c-grid__list--flow">
        { items }
      </ul>
    </>
  )
}

const Faq = () => {
  const addText = [
    [
      "実習生を受け入れたいけど、まず最初にどうしたらいいですか？",
      "業種や規模により、受け入れ可能な範囲が異なります。実習生を受け入れたいと考えている仕事内容や、貴社の従業員数など、結協同組合へお知らせください。他にご不明点があれば、ホームページの「お問い合わせ」ボタンか、お電話にてお気軽にお問い合わせください。(TEL:0796-34-9337)　簡単なご質問からでも大歓迎です。",
    ],
    [
      "どんな職種でも技能実習生の受け入れは可能ですか？",
      "受入れ可能な職種は基本的に技能実習法の要件を満たすもので、結協同組合では主に農業畜産関係・製造業・建設業・食品製造関係で受け入れ可能です。<br>※貴社が3年または5年間の受入れが可能職種かどうかお調べいたします。お気軽にお問い合わせください。",
    ],
    [
      "事務手続きのサポートはありますか？",
      "煩雑な事務処理にも寄り添ってサポートをさせていただきます。",
    ],
    [
      "技能実習生は日本語は喋れますか？",
      "技能実習生は、送出し機関で４ヶ月間、日本語を中心とした事前講習を受講します。入国後も約1ヶ月講習を行いますので、簡単な日本語やマナーは分かります。",
    ],
    [
      "実習生が病気や怪我をした場合はどうなりますか？",
      "企業様ごとに担当者を設けております。お困りの際は担当者へ直接お電話、もしくはメールでご連絡頂けます。また、実習生は結協同組合へ直接相談できるような体制も取っております。",
    ],
  ];
  return (
    <>
      <div className="l-row l-row--normal" data-state="min">
        <Title slug="qa" type="center"></Title>
        <Space size={["80px 0 0", "64px 0 0"]}>
          <QA addText={addText} slug="qa" length={addText.length}></QA>
        </Space>
      </div>
    </>
  );
};

const Follow = () => {
  const args = {
    addText: [
      [
        "煩雑な申請書類等の手続きを一括管理！",
        "技能実習生の入国前から帰国までには様々な在留諸申請を行う必要があり、当組合では専門知識を有したスタッフがこのような手続きを一括管理しております。初めて技能実習生を受け入れる場合には受け入れ要件から在留期間中の手続きにご協力いただくことまで、分かりやすく丁寧にご説明させていただきます。",
      ],
      [
        "コンプライアンス遵守への手厚いフォロー",
        "技能実習法、入管法、労働基準法など技能実習生の受け入れには実習制度の理解とコンプライアンスが最重要視されます。当組合では、受け入れ契約前の事前説明に重点を置き、実習制度・コンプライアンスに対して十分ご理解いただいた上で受け入れをおこなっていただいております。配属後は実習状況・賃金の支払い状況などを確認し、適正に技能実習を実施できるよう指導・助言を行っております。",
      ],
      [
        "専任スタッフが月に一回以上の訪問指導",
        "技能実習生の受け入れにあたり、国民性・異文化による考え方の違い、意思疎通などの難しさなどの不安があるかと思います。当組合では実習実施者（受け入れ企業）ごとの専任スタッフが月一回以上の訪問指導を行い、実習・生活面を指導いたします。また、母国語に対応した相談体制を構築することで指導の通訳・精神的ケアなどにも重点を置き、安心して技能実習を実施できるよう努めております。",
      ],
      [
        "信頼できる送出機関を選定いたします",
        "送出機関は技能実習生の募集・選抜後から出国までの事前講習を行います。当組合では実習制度を十分に理解し、信頼できる送出機関を選定。実習期間中は技能実習生・実習実施者・当組合が主体的な関係となりますが、トラブルが発生した時などは母国で関わる機関の立場から対処・指導等を行ってもらいます。また、送出機関のスタッフによる実習実施者への定期的な巡回訪問の実施を進めております。",
      ],
    ],
  };
  const Item = (props) => {
    return (
      <>
        <Scroll>
          <li className="c-grid__items--square">
            <Media src={`follow/list${props.index}`} class="p-img__follow" alt="media" />
            <div className="c-grid__items--square__inner">
              <Space size={["40px 0 24px", "32px 0 24px"]}>
                <div className="p-title__wrap--en" data-state='center'>
                  <Texts
                    slug={`follow/title${props.index}`}
                    addText={args.addText[props.index][0]}
                  ></Texts>
                </div>
              </Space>
              <Texts
                slug={`follow/body${props.index}`}
                addText={args.addText[props.index][1]}
              ></Texts>
            </div>
          </li>
        </Scroll>
      </>
    );
  };
  let items = [];
  for (let i = 0; i < 4; i++) {
    items.push(<Item key={i} index={i}></Item>);
  }
  return (
    <>
      <Title slug="follow" type="center"></Title>
      <Space size={["80px 0 0", "64px 0 0"]}>
        <ul className="c-grid__list--follow">{items}</ul>
      </Space>
    </>
  );
};

const Information = () => {
  const addText = [
    [
      "<b>技能実習責任者</b><br>事業所毎に1名",
      "・実習実施者に所属する常勤の役職員<br>・自己以外の技能実習指導員・生活指導員及びその他技能実習に関する職員を監理できる立場の者<br>・過去3年以内に技能実習責任者講習（法務大臣及び厚生労働大臣が告示で定めるもの）を終了した者（経過措置あり）<br>・技能実習責任者の欠格事由（違法行為等）に該当していない者<br>",
    ],
    [
      "<b>技能実習指導員</b><br>事業所毎に1名以上",
      "・技能実習を行わせる事業所に所属する常勤の役職員<br>・修得等させる技能等につき5年以上の経験を有する者<br>・技能実習指導員の欠格事由（違法行為等）に該当していない者",
    ],
    [
      "<b>生活指導員</b><br>事業所毎に1名以上",
      "・技能実習を行わせる事業所に所属する常勤の役職員<br>・生活指導員の欠格事由（違法行為等）に該当していない者",
    ],
  ];
  return (
    <>
      <div className="l-row l-row--normal" data-state="min">
        <Title slug="information" type="center"></Title>
        <Space size={["48px", "32px"]}></Space>
        <Table slug="information" len="3" addText={addText}></Table>
        <Space size={["16px 0 0", "8px 0 0"]}>
          <Texts slug="information/bottom" class="c-text--end"></Texts>
        </Space>
      </div>
    </>
  );
};

export default Flow;
